import { render, staticRenderFns } from "./imgW.vue?vue&type=template&id=377d729e"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('377d729e')) {
      api.createRecord('377d729e', component.options)
    } else {
      api.reload('377d729e', component.options)
    }
    module.hot.accept("./imgW.vue?vue&type=template&id=377d729e", function () {
      api.rerender('377d729e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgW.vue"
export default component.exports